import React, { memo } from "react";

import { classNames } from "helpers";
import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { NotificationSceneProps } from "../types";

/** Koliko termina slanja stane na karticu uz istek. */
const VISIBLE_SCHEDULE_ITEMS = 3;

/** Korak "Pravila slanja": plan slanja do isteka, pa ponavljanje. */
const NotificationRulesScene: React.FC<NotificationSceneProps> = ({ notification }) => {
  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Plan slanja</div>
          <div className="text-sm font-bold text-slate-800 truncate">{notification.daysBeforeExpiry} dana prije isteka</div>
          <div className="mt-3 space-y-2">
            {notification.schedule.slice(0, VISIBLE_SCHEDULE_ITEMS).map((item, index) => (
              <div key={item.label} className="flex items-center justify-between gap-2 rounded-md bg-slate-50 px-3 py-2 text-[0.7rem]">
                <span className="flex items-center gap-2 min-w-0">
                  <span className={classNames("w-2 h-2 rounded-full flex-shrink-0", index === 0 ? "bg-blue-600" : "bg-emerald-500")} />
                  <span className="font-medium text-slate-700 truncate">{item.label}</span>
                </span>
                <span className="font-semibold text-slate-800">{item.date}</span>
              </div>
            ))}
            <div className="flex items-center justify-between gap-2 rounded-md bg-red-50 px-3 py-2 text-[0.7rem]">
              <span className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-red-500" />
                <span className="font-medium text-red-700">Istek</span>
              </span>
              <span className="font-semibold text-red-700">{notification.expiryDate}</span>
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-[0.65rem] font-semibold uppercase tracking-wide text-slate-400">Ponavljanje</div>
          <div className="mt-2 text-xs font-bold text-slate-800">{notification.repeatText}</div>
          <div className="mt-1 text-[0.65rem] leading-relaxed text-slate-400">Dok se rok ne produži ili ponavljanja ne istroše.</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        {notification.notifyIfDateMissing ? (
          <ShowcaseNotice
            title="Javljamo i bez datuma"
            subtitle="Kad rok nije upisan u evidenciju"
            iconClassName="bg-amber-100"
            icon={
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#B45309" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01" />
              </svg>
            }
          />
        ) : (
          <ShowcaseNotice
            title="Plan za svaku stavku"
            subtitle="Računa se od njenog datuma isteka"
            iconClassName="bg-blue-100"
            icon={
              <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <path d="M16 2v4M8 2v4M3 10h18" />
              </svg>
            }
          />
        )}
      </ShowcaseCard>
    </>
  );
};

export default memo(NotificationRulesScene);
